const servers = {
    //PRO
    "practicasacademicas.nebrija.es": "https://gestiondcp.nebrija.es",
    //PRE
    "tutores-nebrija.dev.doubledot.es": "https://sandbox-nebrija.dotia.es",
    //FORMACIÓN
    "tutores-nebrija2.dev.doubledot.es": "https://sandbox-nebrija2.dotia.es",
    //LOCAL
     "localhost:8080" : "https://localhost:44379",
}

export default servers;


// WEBPACK FOOTER //
// ./src/servers/index.js